import { render } from "./AISupportPage.vue?vue&type=template&id=bb54ea1e&scoped=true"
import script from "./AISupportPage.vue?vue&type=script&lang=js"
export * from "./AISupportPage.vue?vue&type=script&lang=js"

import "./AISupportPage.vue?vue&type=style&index=0&id=bb54ea1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb54ea1e"]])

export default __exports__